import { useTranslation } from "react-i18next";
import { Card, CardContent } from "@/components/ui/card";

interface VerificationStatusCardProps {
	userType: "designer" | "contractor";
	reviewStatus: "pending" | "approved" | "rejected" | undefined;
	reviewNotes?: string | null;
}

/**
 * Surfaces why a designer/contractor profile isn't verified yet, instead of
 * a flat "pending" message with no way to tell rejected from still-in-queue.
 */
export function VerificationStatusCard({
	userType,
	reviewStatus,
	reviewNotes,
}: VerificationStatusCardProps) {
	const { t } = useTranslation();

	if (reviewStatus === "rejected") {
		return (
			<Card className="border-destructive/50">
				<CardContent className="p-6">
					<h2 className="text-lg font-semibold text-foreground">
						{t("dashboard.verificationRejected")}
					</h2>
					<p className="mt-2 text-muted-foreground">
						{t("dashboard.verificationRejectedMsg")}
					</p>
					{reviewNotes && (
						<p className="mt-2 text-sm text-muted-foreground">
							{t("dashboard.verificationRejectedReason", {
								reason: reviewNotes,
							})}
						</p>
					)}
				</CardContent>
			</Card>
		);
	}

	return (
		<Card className="border-accent">
			<CardContent className="p-6">
				<h2 className="text-lg font-semibold text-foreground">
					{t("dashboard.verificationPending")}
				</h2>
				<p className="mt-2 text-muted-foreground">
					{t(
						userType === "designer"
							? "dashboard.designerVerificationMsg"
							: "dashboard.contractorVerificationMsg",
					)}
				</p>
			</CardContent>
		</Card>
	);
}
